import postMultipartApiData from 'utils/api/postMultipartApiData';

const postTalentAcquisitionData = (path: string, formData: any): Promise<unknown> =>
  postMultipartApiData(path, formData);

export default postTalentAcquisitionData;
